import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useField, useFormikContext } from 'formik';
import { Box, Flex } from 'reflexbox';

import { Button, TextArea } from '@treams/treams-ui';
import { withFormik } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function Face(props: { type: graphql.EngagementType }) {
	void props.type;

	const { t } = useTranslation();
	const [{ value }] = useField('answer.text');
	const [loading, setLoading] = useState(false);
	const formik = useFormikContext();

	return (
		<Flex flexDirection="column" alignItems="center">
			<Box width={500} maxWidth="calc(100vw - 32px)">
				<TextAreaHOC name="answer.text" minRows={5} />
			</Box>

			{value !== undefined && (
				<Flex mt={4}>
					<Button
						loading={loading}
						title={t('engagement.respond.open.confirm')}
						minWidth={128}
						onClick={async () => {
							setLoading(true);
							await formik.submitForm();
						}}
					/>
				</Flex>
			)}
		</Flex>
	);
}

const TextAreaHOC = withFormik(TextArea);
